export default "__VITE_ASSET__D95A1AOE__"